module.exports = __webpack_public_path__ + "img/loudly_crying_face.08c5a46e.gif";